import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { WebExpensePage } from '@/features/billing/pages/WebExpensePage';

export const Route = createFileRoute('/_auth/billing/web-expense')({
  component: () => (
    <ErrorBoundary moduleName="Web Expense Info">
      <Suspense fallback={<PageLoader />}>
        <WebExpensePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
